{
  "archived": {
    "backToStreams": "Back to streams",
    "body": "Its subscription expired and the media was deleted on {{date}}.",
    "buyNew": "Buy a new plan",
    "fileDuration": "Duration",
    "fileName": "File",
    "files": "{{count}} files, {{bytes}}",
    "fileSize": "Size",
    "plan": "Plan at the time",
    "title": "This stream was archived"
  },
  "confirmCharge": {
    "body": "You'll be charged the prorated difference now, to your card on file.",
    "title": "Charge now?"
  },
  "checkoutReturn": {
    "cancelledSubtitle": "No payment was taken. You can pick a plan again any time.",
    "cancelledTitle": "Checkout cancelled",
    "goToStreams": "Go to my streams",
    "notFoundSubtitle": "If you just paid, the stream will still appear in your list.",
    "notFoundTitle": "We couldn't find that checkout",
    "compensatedSubtitle": "The purchase did not complete. No new stream was created.",
    "compensatedTitle": "Checkout was safely reversed",
    "compensatingSubtitle": "Keep this page open while the verified payment is reversed safely.",
    "compensatingTitle": "We’re safely reversing this checkout",
    "failedSubtitle": "Retry to finish. This won't start a second purchase.",
    "failedTitle": "We couldn't finish setting up your stream",
    "retry": "Retry",
    "settingUp": "Setting up your stream…",
    "settingUpSubtitle": "We're confirming your payment with Stripe.",
    "timeoutSubtitle": "We haven't confirmed your payment yet. If it went through, your stream appears in your list. Retry to check again.",
    "timeoutTitle": "Payment confirmation unavailable",
    "verifiedSubtitle": "Your stream is still being set up.",
    "verifiedTitle": "Payment verified"
  },
  "chooser": {
    "ackQualityLoss": "I understand that moving from 4K to Basic permanently deletes my 4K source files and keeps 1080p copies.",
    "blocksLabel": "Extra storage blocks (10 GB each)",
    "blocksTotal": "Total storage: {{total}}",
    "cancel": "Cancel",
    "current": "Current plan",
    "deleteNotice": "You will need to delete {{bytes}} before this plan can be applied.",
    "downgradeScheduled": "Downgrade to Basic scheduled for {{date}}.",
    "kindConvert": "Continue to payment",
    "kindDowngrade": "Schedule downgrade",
    "kindResubscribe": "Continue to payment",
    "kindUpgrade": "Upgrade now",
    "perMonth": "/month",
    "priceUnavailable": "Prices are temporarily unavailable. Please try again.",
    "reasons": {
      "archived": "This slot is archived. Purchase a new slot.",
      "basicVideoLoopOnly": "Basic supports video loop streams only.",
      "billingDisabled": "Billing changes are not enabled yet. Try again after billing is enabled.",
      "billingPaused": "Billing changes are temporarily paused. Try again later.",
      "cleanupPending": "Wait for media cleanup to complete.",
      "dataRepairRequired": "Subscription period data requires repair.",
      "gracePeriodEnded": "The restoration period has ended. Purchase a new slot.",
      "operationInProgress": "Wait for the current billing operation to complete.",
      "renewalRequired": "Enable renewal before scheduling a downgrade.",
      "stopBeforeUpgrading": "Stop the stream before upgrading.",
      "storageOverCap": "Delete media before switching to Basic."
    },
    "select": "Choose {{plan}}",
    "titleCheckout": "Buy a streaming slot",
    "titleStream": "Change plan",
    "totalPrice": "{{price}}/month",
    "upgraded": "Plan upgraded.",
    "videoLoopOnly": "Video loop only",
    "qualityLossTitle": "Your 4K source files will be deleted"
  },
  "converting": {
    "body": "{{pending}} file(s) still encoding. Uploads are paused until the switch completes.",
    "done": "Stream switched: {{promoted}} file(s) ready, {{failed}} failed.",
    "failed": "{{failed}} failed.",
    "restarted": "The live stream was restarted on the new plan.",
    "title": "Switching this stream to Basic"
  },
  "dunning": {
    "bannerDescription": "Streams keep running for 5 days after the first failure, then stop. Retry now or update your card.",
    "bannerMany": "Payments for {{count}} of your streams failed.",
    "bannerOne": "A payment for one of your streams failed.",
    "cardBody": "This stream stops on {{deadline}} unless the payment goes through. Retry the payment or update your card.",
    "cardTitle": "Payment failed",
    "retry": "Retry payment",
    "retryAll": "Retry all",
    "retryAllResult": "{{paid}} of {{attempted}} payments succeeded.",
    "outcome": {
      "declined": "The payment was declined. Update your card and try again.",
      "failed": "The payment retry could not be completed. Try again.",
      "paid": "Payment succeeded.",
      "pending": "The payment is still pending.",
      "requires_action": "Payment authentication is required. Update your card to continue."
    },
    "shortOutcome": {
      "declined": "Declined",
      "failed": "Retry failed",
      "paid": "Paid",
      "pending": "Pending",
      "requires_action": "Authentication required"
    },
    "updateCard": "Update card"
  },
  "paymentAction": {
    "body": "Open the secure Stripe page to approve the charge with your bank.",
    "cta": "Authenticate payment",
    "title": "Your bank needs you to confirm this payment"
  },
  "grace": {
    "body": "This stream is read-only. Its media is deleted on {{date}} unless you resubscribe.",
    "cta": "Resubscribe",
    "endedBody": "This stream's media is being deleted. Buy a new streaming slot from your stream list to stream again.",
    "endedTitle": "Restoration period ended",
    "title": "Subscription expired"
  },
  "home": {
    "buySlot": "Buy a streaming slot",
    "startTrial": "Start free trial",
    "trialSubtitle": "A Basic 1080p video loop stream, free for 24 hours."
  },
  "panel": {
    "cancel": "Cancel subscription",
    "cancelBody": "It keeps running until {{date}}, then stops. You can undo this until then.",
    "cancelled": "Subscription cancelled.",
    "cancelsOn": "Cancels on {{date}}",
    "cancelTitle": "Cancel this stream's subscription?",
    "changePlan": "Change plan",
    "confirm": "Confirm",
    "kept": "Subscription kept.",
    "manageBilling": "Manage billing",
    "plan": "Plan",
    "renewsOn": "Renews on {{date}}",
    "status": {
      "active": "Active",
      "archived": "Archived",
      "expired": "Expired",
      "past_due": "Past due",
      "trialing": "Trial"
    },
    "title": "Subscription",
    "uncancel": "Keep subscription"
  },
  "pending": {
    "body": "This stream moves to Basic on {{date}}{{blocks}}.",
    "keep": "Keep current plan",
    "title": "Downgrade scheduled",
    "withBlocks": " with {{count}} extra storage block(s)",
    "blocksChanges": "Cancel the scheduled downgrade before changing your plan or storage."
  },
  "pendingStorage": {
    "title": "Storage reduction scheduled",
    "body": "On {{date}} your storage drops to {{cap}}. Keep your files under that by then.",
    "keep": "Keep current storage",
    "kept": "Storage reduction cancelled.",
    "blocksChanges": "Keep your current storage first to change it again."
  },
  "operation": {
    "contactSupport": "This update can't be retried automatically. Please contact support at info@streaminal.com.",
    "declinedTitle": "Payment declined",
    "pendingBody": "The current billing update is still being applied.",
    "pendingTitle": "Billing update in progress",
    "retry": "Retry billing update",
    "retryBody": "It stopped partway. Retry to finish it.",
    "retryTitle": "This change didn't finish",
    "failedTitle": "This change couldn't be made"
  },
  "plans": {
    "basic": {
      "features": [
        "1080p",
        "20 GB storage, expandable to 70 GB",
        "Video loop streams only"
      ],
      "name": "Basic",
      "overlaysUnavailable": "No overlays",
      "tagline": "Video loop streams at 1080p, pre-encoded for the lowest price."
    },
    "r1080p": {
      "features": [
        "1080p",
        "80 GB storage",
        "All stream types",
        "Overlays and custom elements"
      ],
      "name": "Pro",
      "tagline": "Full pipeline: overlays, radio streams, shows, jingles."
    },
    "r2160p": {
      "features": [
        "4K (2160p)",
        "250 GB storage",
        "All stream types",
        "Overlays and custom elements"
      ],
      "name": "4K",
      "tagline": "Everything in Pro at 4K."
    }
  },
  "storage": {
    "apply": "Apply",
    "blocks": "Extra storage",
    "blocksHint": "10 GB per block, up to {{max}}",
    "blocksPrice": "{{price}} per block per month",
    "priceUnavailable": "Storage price unavailable. Try again before adding storage.",
    "reduceBody": "On {{date}} your storage drops to {{cap}}. You keep the current space until then, and this month isn't refunded. Keep your files under {{cap}} by that date.",
    "reduceTitle": "Reduce storage at renewal?",
    "reductionScheduled": "Storage drops to {{cap}} on {{date}}.",
    "reserved": "{{reserved}} reserved for uploads in progress",
    "retryPrice": "Retry price",
    "title": "Storage",
    "updated": "Storage updated: {{cap}} total.",
    "used": "{{used}} of {{cap}} used"
  },
  "trial": {
    "body": "Your Basic trial stream stops when the trial ends. Subscribe to keep it running.",
    "cta": "Subscribe to keep this stream running",
    "ended": "Trial ended",
    "endsIn": "Ends in {{timeLeft}}",
    "title": "Free trial",
    "endedBody": "Your trial stream has stopped. Subscribe to start it again.",
    "endedCta": "Subscribe"
  },
  "time": {
    "hoursMinutes": "{{hours}}h {{minutes}}m",
    "minutes": "{{minutes}}m"
  }
}
